import { Endpoint } from '../endpoint';
import { AddManualCommissionRequest, CommissionResponse, UpdateManualCommissionRequest } from '@business/entities/commission';
import { CommissionFormData } from '@modules/settings/SettingsPage/Components/CommissionSettingsTab/CommissionTab';

export function fetchCommissions() {
  return Endpoint.get<CommissionResponse[]>(`@gc/commission`);
}

export function saveCommissions(data: CommissionFormData) {
  return Endpoint.post<CommissionResponse[]>(`@gc/commission`, { data });
}

export function saveManualCommission(data: AddManualCommissionRequest) {
  return Endpoint.post<{ success: boolean }>(`@gc/commission/manual`, { data });
}

export function updateManualCommission(id: string, data: UpdateManualCommissionRequest) {
  return Endpoint.put<{ success: boolean }>(`@gc/commission/manual/${id}`, { data });
}

export function deleteManualCommission(id: string) {
  return Endpoint.delete<void>(`@gc/commission/manual/${id}`);
}

export function saveSplitOverrides(data: any) {
  return Endpoint.post<void>(`@gc/commission/split-overrides`, { data });
}

export function getSplitOverrides() {
  return Endpoint.get<any[]>(`@gc/commission/split-overrides`);
}
